export const coinsList = {
    ALPHA: {
        name: 'ALPHA',
        type: '0xfe3afec26c59e874f3c1d60b8203cb3852d2bb2aa415df9548b8d688e6683f93::alpha::ALPHA',
        icon: 'https://7taj6jfau6n3dri7agspzfnva7qbj5sizz5xc3lb56nmxpsyoiba.arweave.net/_MCfJKCnm7HFHwGk_JW1B-AU9kjOe3FtYe-ay75YcgI',
        expo: 9,
    },
    SUI: {
        name: 'SUI',
        type: '0x0000000000000000000000000000000000000000000000000000000000000002::sui::SUI',
        icon: 'https://coinmeta.polymedia.app/img/coins/0x0000000000000000000000000000000000000000000000000000000000000002-sui-SUI.svg',
        expo: 9,
    },
    USDC: {
        name: 'USDC',
        type: '0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC',
        icon: 'https://coinmeta.polymedia.app/img/coins/0x5d4b302506645c37ff133b98c4b50a5ae14841659738d6d733d59d0d217a93bf-coin-COIN.webp',
        expo: 6,
    },
    WUSDC: {
        name: 'WUSDC',
        type: '0x5d4b302506645c37ff133b98c4b50a5ae14841659738d6d733d59d0d217a93bf::coin::COIN',
        icon: 'https://coinmeta.polymedia.app/img/coins/0x5d4b302506645c37ff133b98c4b50a5ae14841659738d6d733d59d0d217a93bf-coin-COIN.webp',
        expo: 6,
    },
    USDT: {
        name: 'USDT',
        type: '0xc060006111016b8a020ad5b33834984a437aaa7d3c74c18e09a95d48aceab08c::coin::COIN',
        icon: 'https://coinmeta.polymedia.app/img/coins/0xc060006111016b8a020ad5b33834984a437aaa7d3c74c18e09a95d48aceab08c-coin-COIN.webp',
        expo: 6,
    },
    VSUI: {
        name: 'VSUI',
        type: '0x549e8b69270defbfafd4f94e17ec44cdbdd99820b33bda2278dea3b9a32d3f55::cert::CERT',
        icon: 'https://coinmeta.polymedia.app/img/coins/0x549e8b69270defbfafd4f94e17ec44cdbdd99820b33bda2278dea3b9a32d3f55-cert-CERT.webp',
        expo: 9,
    },
    NAVX: {
        name: 'NAVX',
        type: '0xa99b8952d4f7d947ea77fe0ecdcc9e5fc0bcab2841d6e2a5aa00c3044e5544b5::navx::NAVX',
        icon: 'https://coinmeta.polymedia.app/img/coins/0xa99b8952d4f7d947ea77fe0ecdcc9e5fc0bcab2841d6e2a5aa00c3044e5544b5-navx-NAVX.webp',
        expo: 9,
    },
    SCA: {
        name: 'SCA',
        type: '0x7016aae72cfc67f2fadf55769c0a7dd54291a583b63051a5ed71081cce836ac6::sca::SCA',
        icon: 'https://coinmeta.polymedia.app/img/coins/0x7016aae72cfc67f2fadf55769c0a7dd54291a583b63051a5ed71081cce836ac6-sca-SCA.webp',
        expo: 9,
    },
    CETUS: {
        name: 'CETUS',
        type: '0x06864a6f921804860930db6ddbe2e16acdf8504495ea7481637a1c8b9a8fe54b::cetus::CETUS',
        icon: 'https://coinmeta.polymedia.app/img/coins/0x06864a6f921804860930db6ddbe2e16acdf8504495ea7481637a1c8b9a8fe54b-cetus-CETUS.webp',
        expo: 9,
    },
    TURBOS: {
        name: 'TURBOS',
        type: '0x5d1f47ea69bb0de31c313d7acf89b890dbb8991ea8e03c6c355171f84bb1ba4a::turbos::TURBOS',
        icon: 'https://coinmeta.polymedia.app/img/coins/0x5d1f47ea69bb0de31c313d7acf89b890dbb8991ea8e03c6c355171f84bb1ba4a-turbos-TURBOS.svg',
        expo: 9,
    },
    AFSUI: {
        name: 'AFSUI',
        type: '0xf325ce1300e8dac124071d3152c5c5ee6174914f8bc2161e88329cf579246efc::afsui::AFSUI',
        icon: 'https://coinmeta.polymedia.app/img/coins/0xf325ce1300e8dac124071d3152c5c5ee6174914f8bc2161e88329cf579246efc-afsui-AFSUI.webp',
        expo: 9,
    },
    WETH: {
        name: 'WETH',
        type: '0xaf8cd5edc19c4512f4259f0bee101a40d41ebed738ade5874359610ef8eeced5::coin::COIN',
        icon: 'https://coinmeta.polymedia.app/img/coins/0xaf8cd5edc19c4512f4259f0bee101a40d41ebed738ade5874359610ef8eeced5-coin-COIN.webp',
        expo: 8,
    },
    APT: {
        name: 'APT',
        type: '0x3a5143bb1196e3bcdfab6203d1683ae29edd26294fc8bfeafe4aaa9d2704df37::coin::COIN',
        icon: 'https://coinmeta.polymedia.app/img/coins/0x3a5143bb1196e3bcdfab6203d1683ae29edd26294fc8bfeafe4aaa9d2704df37-coin-COIN.webp',
        expo: 8,
    },
    WSOL: {
        name: 'WSOL',
        type: '0xb7844e289a8410e50fb3ca48d69eb9cf29e27d223ef90353fe1bd8e27ff8f3f8::coin::COIN',
        icon: 'https://coinmeta.polymedia.app/img/coins/0xb7844e289a8410e50fb3ca48d69eb9cf29e27d223ef90353fe1bd8e27ff8f3f8-coin-COIN.webp',
        expo: 8,
    },
    SLP: {
        name: 'SLP',
        type: '0xc44d97a4bc4e5a33ca847b72b123172c88a6328196b71414f32c3070233604b2::slp::SLP',
        icon: 'https://coinmeta.polymedia.app/img/coins/0xc44d97a4bc4e5a33ca847b72b123172c88a6328196b71414f32c3070233604b2-slp-SLP.webp',
        expo: 6,
    },
    WBTC: {
        name: 'WBTC',
        type: '0x027792d9fed7f9844eb4839566001bb6f6cb4804f66aa2da6fe1ee242d896881::coin::COIN',
        icon: 'https://coinmeta.polymedia.app/img/coins/0x027792d9fed7f9844eb4839566001bb6f6cb4804f66aa2da6fe1ee242d896881-coin-COIN.webp',
        expo: 8,
    },
    CELO: {
        name: 'CELO',
        type: '0xa198f3be41cda8c07b3bf3fee02263526e535d682499806979a111e88a5a8d0f::coin::COIN',
        icon: 'https://coinmeta.polymedia.app/img/coins/0xa198f3be41cda8c07b3bf3fee02263526e535d682499806979a111e88a5a8d0f-coin-COIN.webp',
        expo: 8,
    },
    HASUI: {
        name: 'HASUI',
        type: '0xbde4ba4c2e274a60ce15c1cfff9e5c42e41654ac8b6d906a57efa4bd3c29f47d::hasui::HASUI',
        icon: 'https://coinmeta.polymedia.app/img/coins/0xbde4ba4c2e274a60ce15c1cfff9e5c42e41654ac8b6d906a57efa4bd3c29f47d-hasui-HASUI.svg',
        expo: 9,
    },
    USDY: {
        name: 'USDY',
        type: '0x960b531667636f39e85867775f52f6b1f220a058c4de786905bdf761e06a56bb::usdy::USDY',
        icon: 'https://coinmeta.polymedia.app/img/coins/0x960b531667636f39e85867775f52f6b1f220a058c4de786905bdf761e06a56bb-usdy-USDY.svg',
        expo: 6,
    },
    BUCK: {
        name: 'BUCK',
        type: '0xce7ff77a83ea0cb6fd39bd8748e2ec89a3f41e8efdc3f4eb123e0ca37b184db2::buck::BUCK',
        icon: 'https://imagedelivery.net/cBNDGgkrsEA-b_ixIp9SkQ/buck.svg/public',
        expo: 9,
    },
    FUD: {
        name: 'FUD',
        type: '0x76cb819b01abed502bee8a702b4c2d547532c12f25001c9dea795a5e631c26f1::fud::FUD',
        icon: '',
        expo: 5,
    },
    BLUB: {
        name: 'BLUB',
        type: '0xfa7ac3951fdca92c5200d468d31a365eb03b2be9936fde615e69f0c1274ad3a0::BLUB::BLUB',
        icon: '',
        expo: 2,
    },
    ETH: {
        name: 'ETH',
        type: '0xd0e89b2af5e4910726fbcd8b8dd37bb79b29e5f83f7491bca830e94f7f226d29::eth::ETH',
        icon: '',
        expo: 8,
    },
    DEEP: {
        name: 'DEEP',
        type: '0xdeeb7a4662eec9f2f3def03fb937a663dddaa2e215b8078a284d026b7946c270::deep::DEEP',
        icon: '',
        expo: 6,
    },
    AUSD: {
        name: 'AUSD',
        type: '0x2053d08c1e2bd02791056171aab0fd12bd7cd7efad2ab8f6b9c8902f14df2ff2::ausd::AUSD',
        icon: '',
        expo: 6,
    },
    NS: {
        name: 'NS',
        type: '0x5145494a5f5100e645e4b0aa950fa6b68f614e8c59e17bc5ded3495123a79178::ns::NS',
        icon: '',
        expo: 6,
    },
    BLUE: {
        name: 'BLUE',
        type: '0xe1b45a0e641b9955a20aa0ad1c1f4ad86aad8afb07296d4085e349a50e90bdca::blue::BLUE',
        icon: '',
        expo: 9,
    },
    SEND: {
        name: 'SEND',
        type: '0xb45fcfcc2cc07ce0702cc2d229621e046c906ef14d9b25e8e4d25f6e8763fef7::send::SEND',
        icon: '',
        expo: 6,
    },
    STSUI: {
        name: 'STSUI',
        type: '0xd1b72982e40348d069bb1ff701e634c117bb5f741f44dff91e472d3b01461e55::stsui::STSUI',
        icon: '',
        expo: 9,
    },
    SUIUSDT: {
        name: 'SUIUSDT',
        type: '0x375f70cf2ae4c00bf37117d0c85a2c71545e6ee05c4a5c7d282cd66a4504b068::usdt::USDT',
        icon: '',
        expo: 6,
    },
    MUSD: {
        name: 'MUSD',
        type: '0xe44df51c0b21a27ab915fa1fe2ca610cd3eaa6d9666fe5e62b988bf7f0bd8722::musd::MUSD',
        icon: '',
        expo: 9,
    },
    FT_BLUEFIN_STSUI_SUI: {
        name: 'FT_BLUEFIN_STSUI_SUI',
        type: '0xcd8f8a6fcd309e6d00f6f8f2d37eeeedeee7ccb50934d457e5a0a2f3e65bdbd2::ft_bluefin_stsui_sui::FT_BLUEFIN_STSUI_SUI',
        icon: '',
        expo: 9,
    },
    'AlphaFi stSUI-SUI LP': {
        name: 'AlphaFi stSUI-SUI LP',
        type: '0x96eb2012a75798ce4410392baeab9dd888bc704799b7daa468c36856c83174f3::ALPHAFI_STSUI_SUI_LP::ALPHAFI_STSUI_SUI_LP',
        icon: '',
        expo: 9,
    },
    SUIBTC: {
        name: 'SUIBTC',
        type: '0xaafb102dd0902f5055cadecd687fb5b71ca82ef0e0285d90afde828ec58ca96b::btc::BTC',
        icon: '',
        expo: 8,
    },
    LBTC: {
        name: 'LBTC',
        type: '0x3e8e9423d80e1774a7ca128fccd8bf5f1f7753be658c5e645929037f7c819040::lbtc::LBTC',
        icon: '',
        expo: 8,
    },
    WAL: {
        name: 'WAL',
        type: '0x356a26eb9e012a68958082340d4c4116e7f55615cf27affcff209cf0ae544f59::wal::WAL',
        icon: '',
        expo: 9,
    },
    DMC: {
        name: 'DMC',
        type: '0x4c981f3ff786cdb9e514da897ab8a953647dae2ace9679e8358eec1e3e8871ac::dmc::DMC',
        icon: '',
        expo: 9,
    },
    TBTC: {
        name: 'TBTC',
        type: '0x77045f1b9f811a7a8fb9ebd085b5b0c55c5cb0d1520ff55f7037f89b5da9f5f1::TBTC::TBTC',
        icon: '',
        expo: 8,
    },
    IKA: {
        name: 'IKA',
        type: '0x7262fb2f7a3a14c888c438a3cd9b912469a58cf60f367352c46584262e8299aa::ika::IKA',
        icon: '',
        expo: 9,
    },
    XBTC: {
        name: 'XBTC',
        type: '0x876a4b7bce8aeaef60464c11f4026903e9afacab79b9b142686158aa86560b50::xbtc::XBTC',
        icon: '',
        expo: 8,
    },
    ALKIMI: {
        name: 'ALKIMI',
        type: '0x1a8f4bc33f8ef7fbc851f156857aa65d397a6a6fd27a7ac2ca717b51f2fd9489::alkimi::ALKIMI',
        icon: '',
        expo: 9,
    },
    XAUM: {
        name: 'XAUM',
        type: '0x9d297676e7a4b771ab023291377b2adfaa4938fb9080b8d12430e4b108b836a9::xaum::XAUM',
        icon: '',
        expo: 9,
    },
    UP: {
        name: 'UP',
        type: '0x87dfe1248a1dc4ce473bd9cb2937d66cdc6c30fee63f3fe0dbb55c7a09d35dec::up::UP',
        icon: '',
        expo: 6,
    },
    ESUI: {
        name: 'ESUI',
        type: '0x66629328922d609cf15af779719e248ae0e63fe0b9d9739623f763b33a9c97da::esui::ESUI',
        icon: '',
        expo: 9,
    },
    EBTC: {
        name: 'EBTC',
        type: '0x244b98d29bd0bba401c7cfdd89f017c51759dad615e15a872ddfe45af079bb1d::ebtc::EBTC',
        icon: '',
        expo: 8,
    },
    EGUSDC: {
        name: 'EGUSDC',
        type: '0x68532559a19101b58757012207d82328e75fde7a696d20a59e8307c1a7f42ad7::egusdc::EGUSDC',
        icon: '',
        expo: 6,
    },
};
export const coinsListByType = Object.values(coinsList).reduce((acc, coin) => {
    acc[coin.type] = coin;
    return acc;
}, {});
//# sourceMappingURL=coinsList.js.map